<template>
  <div style="background-color:#fff;">
    <div class="home-pannel-title">
      <span>客户统计数据</span>
    </div>
    <div ref="myLineChart" style="width: 100%;height:100%;border-radius:10px;"/>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  data () {
    return {
      myLineChart: null
    }
  },
  mounted () {
    this.myLineChart = this.$echarts.init(this.$refs.myLineChart)
    this.initData()
  },
  methods: {
    initData () {
      this.$get('/customer/board').then(res => {
        let xLabel = []
        let dataValue = []
        let dataValue1 = []
        res.data.data.forEach(res => {
          xLabel.push(res.date)
          dataValue.push(res.totalNum)
          dataValue1.push(res.addNum)
        })
        this.createLeftChart(xLabel, dataValue, dataValue1)
      })
      // let xLabel = ['2023年6月1号', '2023年6月6号', '2023年6月11号', '2023年6月16号', '2023年6月21号', '2023年6月26号']
      // let dataValue = [20, 30, 40, 35, 45, 88]
      // let dataValue1 = [100, 50, 22, 15, 55, 78]
    },
    // 客户看板 (近一个月)
    // getCustomBoard () {
    //   // this.$get('/customer/countDay').then(res => {
    //   //   if (res.status === 200 && res.data.status === 1) {
    //   //     var data = res.data.data
    //   //     var dateArr = []
    //   //     var currentArr = []
    //   //     var allArr = []
    //   //     for (let i = 29; i >= 0; i--) {
    //   //       const time = moment().subtract(1, 'months').format('YYYY-MM-DD')
    //   //       for (const o of data) {
    //   //         if (o.date === time) {
    //   //           currentArr.push(o.addNum)
    //   //           allArr.push(o.totalNum)
    //   //         }
    //   //       }
    //   //       dateArr.push(time)
    //   //     }
    //   //     this.$nextTick(() => {
    //   //       this.initEcharts(dateArr, currentArr, allArr)
    //   //     })
    //   //   }
    //   // })
    //   let xLabel = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
    //   let dataValue = [20, 30, 40, 35, 34, 15, 56, 15, 12, 25, 34, 42]
    //   let dataValue1 = [40, 35, 34, 15, 56, 15, 12, 25, 34, 42, 20, 30]
    //   this.$refs.LineKan.createLeftChart(xLabel, dataValue, dataValue1)
    // },
    createLeftChart (xLabel = [], dataValue = [], dataValue1 = []) {
      let option = {
        backgroundColor: '#FFFFFF',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: 'rgb(126,199,255)'
            }
          }
        },
        legend: {
          show: true,
          top: '4%',
          itemWidth: 30, // 图例标记的图形宽度。
          //   itemGap: 20, // 图例每项之间的间隔。
          itemHeight: 10, //  图例标记的图形高度
          textStyle: {
            color: '#061740',
            fontSize: 16,
            padding: [0, 8, 0, 8]
          }
        },
        grid: {
          top: '20%',
          left: '8%',
          right: '8%',
          bottom: '14%'
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              // 坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: 'rgb(41,188,245)'
              }
            },
            axisLabel: {
              // 坐标轴刻度标签的相关设置
              textStyle: {
                color: '#061740',
                fontSize: 14
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#233653'
              }
            },
            axisTick: {
              show: false
            },
            data: xLabel
          }
        ],
        yAxis: [
          {
            name: '',
            nameTextStyle: {
              color: '#FFFFFF',
              fontSize: 12,
              padding: [0, 60, 0, 0]
            },
            // minInterval: 1,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: '#1160a0',
                type: 'dashed'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#008de7'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#061740',
                fontSize: 14
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '当前客户',
            type: 'line',
            // symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
            smooth: true,
            lineStyle: {
              normal: {
                width: 3,
                color: '#25D677' // 线条颜色
              }
            },
            itemStyle: {
              normal: {
                // color: '#00f0ff', // 拐点颜色
                // borderColor: '#fff600',//拐点边框颜色
                // borderWidth: 13//拐点边框大小
                label: {
                  show: true, // 开启显示
                  color: '#061740',
                  position: 'top', // 在上方显示
                  formatter: function (res) {
                    if (res.value) {
                      return res.value
                    } else {
                      return 0
                    }
                  }
                }
              }

            },
            symbolSize: 8, // 设定实心点的大小
            areaStyle: {
              normal: {
                // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: '#00ffa230'
                    },
                    {
                      offset: 0.6,
                      color: '#00ffa220'
                    },
                    {
                      offset: 1,
                      color: '#00ffa210'
                    }
                  ],
                  false
                )
              }
            },
            data: dataValue
          },
          {
            name: '新增客户',
            type: 'line',
            // symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
            smooth: true,
            lineStyle: {
              normal: {
                width: 3,
                color: '#16D6FF' // 线条颜色
              }
            },
            itemStyle: {
              normal: {
                // color: '#fff600', // 拐点颜色
                // borderColor: '#fff600',//拐点边框颜色
                // borderWidth: 13//拐点边框大小
                label: {
                  show: true, // 开启显示
                  color: '061740',
                  position: 'top', // 在上方显示
                  formatter: function (res) {
                    if (res.value) {
                      return res.value
                    } else {
                      return 0
                    }
                  }
                }
              }

            },
            symbolSize: 8, // 设定实心点的大小
            areaStyle: {
              normal: {
                // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: '#ffba0030'
                    },
                    {
                      offset: 0.6,
                      color: '#ffba0020'
                    },
                    {
                      offset: 1,
                      color: '#ffba0010'
                    }
                  ],
                  false
                )
              }
            },
            data: dataValue1
          }
        ]
      }
      this.myLineChart.setOption(option, true)
    }
    // initEcharts (dateArr, currentArr = [], allArr = []) {
    //   // 绘制一个七天的折线图
    //   var option = {
    //     // title: {
    //     //   text: 'Stacked Line'
    //     // },
    //     tooltip: {
    //       trigger: 'axis'
    //     },
    //     legend: {
    //       data: ['当前客户数', '新增客户数'],
    //       top: '10%'
    //     },
    //     grid: {
    //       left: '3%',
    //       right: '4%',
    //       bottom: '10%',
    //       containLabel: true
    //     },
    //     xAxis: {
    //       type: 'category',
    //       boundaryGap: false,
    //       data: this.dateArr
    //     },
    //     yAxis: {
    //       type: 'value'
    //     },
    //     series: [
    //       {
    //         name: '当前客户数',
    //         type: 'line',
    //         data: allArr
    //       },
    //       {
    //         name: '新增客户数',
    //         type: 'line',
    //         data: currentArr
    //       }
    //     ]
    //   }
    //   this.$nextTick(() => {
    //     let myChart = echarts.init(this.$refs.statistic)
    //     myChart.setOption(option, true)
    //   })
    // },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/projectStatis/customerKanBan.vue